var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-content', {
    attrs: {
      "title": "Konsultasi Psikologi: Ruang",
      "with-margin": false
    }
  }, [_vm.rooms.length == 0 ? _c('empty-state', {
    attrs: {
      "icon": "event_note",
      "icon-type": "rounded"
    }
  }) : _vm._e(), _c('br'), _vm._l(_vm.rooms, function (room, index) {
    return _c('div', {
      key: room.id
    }, [_c('div', {
      staticClass: "d-flex align-items-center px-3 py-2"
    }, [_c('span', {
      staticClass: "flex-grow-1"
    }, [_vm._v(_vm._s(room.name))]), _vm.can('update-mental-health-room') ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: 'Ubah',
        expression: "'Ubah'"
      }],
      staticClass: "ml-1 p-1 pointer",
      on: {
        "click": function click($event) {
          return _vm.editRoom(room);
        }
      }
    }, [_c('material-icon', {
      attrs: {
        "name": "edit_note",
        "size": "14"
      }
    })], 1) : _vm._e(), _vm.can('delete-mental-health-room') ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: 'Hapus',
        expression: "'Hapus'"
      }],
      staticClass: "p-1 text-danger pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteRoom(room);
        }
      }
    }, [_c('material-icon', {
      attrs: {
        "name": "delete",
        "size": "14"
      }
    })], 1) : _vm._e()]), index != _vm.rooms.length - 1 ? _c('div', {
      staticClass: "divider"
    }) : _vm._e()]);
  }), _vm.can('create-mental-health-room') ? _c('button', {
    staticClass: "btn btn-success btn-rounded btn-fab d-flex align-items-center",
    on: {
      "click": function click($event) {
        return _vm.addRoom();
      }
    }
  }, [_c('material-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "add",
      "size": "20"
    }
  }), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v("Tambah Ruang")])], 1) : _vm._e(), _c('sweet-modal', {
    ref: "roomForm",
    attrs: {
      "title": _vm.formTitle,
      "overlay-theme": "dark",
      "blocking": ""
    }
  }, [_c('c-input', {
    attrs: {
      "label": "Nama Ruang",
      "placeholder": "Masukkan nama ruang",
      "error": !_vm.isEmpty(_vm.errors.name),
      "error-message": _vm.errors.name
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('button-loading', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "loading": _vm.saveLoading,
      "loading-color": _vm.colorPrimary
    },
    on: {
      "click": function click($event) {
        return _vm.storeRoom();
      }
    }
  }, [_vm._v("\n      Simpan\n    ")])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }